import { Link } from 'react-router-dom'
import { useJsonValues } from '../../hooks'
import {
    StyledBox,
    StyledButton,
    StyledButtonContainer,
    StyledContainer,
    StyledIcon,
    StyledImg,
    StyledImgContainer,
    StyledLinkContainer,
    StyledText1,
    StyledText2,
    StyledText3,
} from './styled'

const Profile = () => {
    const { data } = useJsonValues()

    const {
        image,
        greeting,
        name,
        work,
        downloadCV,
        contactInfo,
        blogLink,
        links = [],
    } = data.profile

    return (
        <StyledContainer id="profile">
            <StyledImgContainer>
                <StyledImg src={image} alt="Samaila Chatto Bashir" />
            </StyledImgContainer>

            <StyledBox>
                <StyledText1>{greeting}</StyledText1>

                <StyledText2>{name}</StyledText2>

                <StyledText3>{work}</StyledText3>

                <StyledButtonContainer>
                    <StyledButton
                        variant="contained"
                        onClick={() =>
                            window.open('/assets/chatto-cv.pdf', '_blank')
                        }
                    >
                        {downloadCV}
                    </StyledButton>
                </StyledButtonContainer>

                <StyledLinkContainer>
                    {links.map(({ link, image }, index) => (
                        <Link to={link} target="_blank" key={index}>
                            <StyledIcon src={image} alt="" height="30px" />
                        </Link>
                    ))}
                </StyledLinkContainer>
            </StyledBox>
        </StyledContainer>
    )
}

export default Profile
